import { NodeVariant } from '../types';
export var MAX_LABEL_LENGTH = 50;
export var MAX_LABEL_LENGTH_DIAMOND_NODE = 10;
export var LABEL_PADDING = 100;
export var DIAMOND_NODE_WIDTH = 150;
export var getNodeShape = function (variant, label, height) {
    var width = getWidthForLabel(label);
    switch (variant) {
        case NodeVariant.DIAMOND:
            return NodeShapeDiamond();
        case NodeVariant.RECT:
            return NodeShapeRect(width, height);
        case NodeVariant.ROUND:
            return NodeShapeRound(width, height);
        default:
            throw new Error('No Node Shape defined for Variant: ' + String(variant));
    }
};
var getWidthForLabel = function (label) {
    var trimmedLabel = label.length <= MAX_LABEL_LENGTH ? label : label.slice(0, MAX_LABEL_LENGTH).concat('...');
    var nodeLayerElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    document.body.appendChild(nodeLayerElement);
    var svgTextElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    svgTextElement.classList.add('interactiveNode__label');
    nodeLayerElement.appendChild(svgTextElement);
    svgTextElement.textContent = trimmedLabel;
    var width = svgTextElement.getBoundingClientRect().width;
    nodeLayerElement.removeChild(svgTextElement);
    document.body.removeChild(nodeLayerElement);
    return width + LABEL_PADDING;
};
// Diamond Node
export var NODE_DIAMOND_HEIGHT = 85;
var NodeShapeDiamond = function () {
    // diamond path:      start point    top-left line     top curve     top-right line    right curve   bot-right line    bot curve    bot-left line     left curve      close
    var diamondPath = 'M -75 -7.5     L -7.5 -40    Q 0 -43 7.5 -40     L 75 -7.5     Q 90 0 75 7.5     L 7.5 40    Q 0 43 -7.5 40    L -75 7.5     Q -90 0 -75 -7.5    Z';
    return {
        name: 'path',
        attrs: {
            d: diamondPath,
        },
    };
};
// Rect Node
var NODE_RECT_MIN_WIDTH = 120;
var NODE_RECT_HEIGHT = 60;
var NODE_RECT_CORNER_RADIUS = 10;
var NodeShapeRect = function (width, height) {
    var rectWidth = width && width > NODE_RECT_MIN_WIDTH ? width : NODE_RECT_MIN_WIDTH;
    var rectHeight = height ? height : NODE_RECT_HEIGHT;
    var rectCornerRadius = NODE_RECT_CORNER_RADIUS;
    return {
        name: 'rect',
        attrs: {
            width: rectWidth,
            height: rectHeight,
            x: -0.5 * rectWidth,
            y: -0.5 * rectHeight,
            rx: rectCornerRadius,
            ry: rectCornerRadius,
        },
    };
};
// Round Node
var NODE_ROUND_MIN_WIDTH = 100;
var NODE_ROUND_HEIGHT = 36;
var NODE_ROUND_CORNER_RADIUS_FACTOR = 0.5;
var NodeShapeRound = function (width, height) {
    var rectWidth = width && width > NODE_ROUND_MIN_WIDTH ? width : NODE_ROUND_MIN_WIDTH;
    var rectHeight = height ? height : NODE_ROUND_HEIGHT;
    var rectCornerRadius = rectHeight * NODE_ROUND_CORNER_RADIUS_FACTOR;
    return {
        name: 'rect',
        attrs: {
            width: rectWidth,
            height: rectHeight,
            x: -0.5 * rectWidth,
            y: -0.5 * rectHeight,
            rx: rectCornerRadius,
            ry: rectCornerRadius,
        },
    };
};
//# sourceMappingURL=NodeShapeFactory.js.map